import { render, staticRenderFns } from "./TransactionTab.vue?vue&type=template&id=d89551e0&scoped=true&"
import script from "./TransactionTab.vue?vue&type=script&lang=js&"
export * from "./TransactionTab.vue?vue&type=script&lang=js&"
import style0 from "./TransactionTab.vue?vue&type=style&index=0&id=d89551e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89551e0",
  null
  
)

export default component.exports